import { render, staticRenderFns } from "./TheProfileFieldsetNotifications.vue?vue&type=template&id=6d0067de&"
import script from "./TheProfileFieldsetNotifications.vue?vue&type=script&lang=js&"
export * from "./TheProfileFieldsetNotifications.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileFieldsetNotifications.vue?vue&type=style&index=0&id=6d0067de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports